import { addMonths, format } from "date-fns";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { PostApi1605, PostApi1607, PostApi1608 } from "../../../modules/network/padoPost";
import { Container, DateLayer, NoData, closeLayerFn, openLayerFn } from "../../Layout";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";

import styled from "styled-components";
import {
  AppContext,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
  SocketCommand,
  checkMobile,
  socketManager,
} from "../../../components/AppProvider";
import { ConfirmLayer } from "../../../components/UI/Dialog";
import { postApiToJson } from "../../../modules/network/Network";
import { _O } from "../../../modules/utils";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import { requestGetNewPoint } from "../../../modules/utils/getNewPoint";
import { reLogin } from "../../common/AutoLogin/AutoLogin";
import { downloadPfFile } from "../../common/DownloadFile/DownloadFile";
import { LoadingLayer } from "../../common/Layer/Loading";
import { SUBS, SubMenu } from "../Pmr";
import useTitle from "../../../modules/hooks/useTitle";

const interfaceDateFormat = "yyyyMMdd";

export default props => {
  useTitle("개인진료기록_제증명_보관함");
  const sub = SUBS[3];
  const [periodType, setPeriodType] = useState(props.match.params.periodType);
  const [startDate, setStartDate] = useState(
    props.match.params.startDate && props.match.params.startDate
  );
  const [endDate, setEndDate] = useState(
    props.match.params.startDate && props.match.params.startDate
  );
  const [resultList, setResultList] = useState();

  const [trgtSeqNo, setTrgtSeqNo] = useState();
  const [trgtHsptCd, setTrgtHsptCd] = useState();
  const [pgCno, setPgCno] = useState();
  const [payMth, setPayMth] = useState();
  const [payAmount, setPayAmount] = useState();

  const [popupMode, setPopupMode] = useState();
  const [downMode, setDownMode] = useState(true);

  const [loading, setLoading] = useState(false);

  const { userinfo, cfg, phonecfg, auth, dispatch, itemState, pageState } =
    useContext(AppContext);

  // msgCount
  const [msgCount, setMsgCount] = useState("");

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
    reloadList();
  };

  const request1605 = userinfo => {
    // 기본 한달치 날짜 셋팅
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
        break;
      default:
        reqStartDate = startDate;
        reqEndDate = endDate;
        break;
    }

    PostApi1605(userinfo, cfg, phonecfg, periodType, reqStartDate, reqEndDate)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setResultList(res.result);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1605Test = userinfo => {
    // 기본 한달치 날짜 셋팅
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -6), interfaceDateFormat);
        break;
      default:
        reqStartDate = startDate;
        reqEndDate = endDate;
        break;
    }

    PostApi1605(userinfo, cfg, phonecfg, periodType, reqStartDate, reqEndDate)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setResultList(res.result);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1607 = (
    hsptCd,
    seqNo,
    payMth,
    payAmount,
    trnsnType,
    trnsnId,
    trnsnRslt
  ) => {
    PostApi1607(
      userinfo,
      cfg,
      phonecfg,
      seqNo,
      payMth,
      payAmount,
      trnsnType,
      trnsnId,
      trnsnRslt
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          request1605(userinfo);
        } else {
          if (res.resultCode === "E002") {
            alert("결제를 취소하지 못했습니다. 고객센터로 문의 부탁드립니다.");
          } else {
            console.log("LOGOUT!!!");
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1608 = seqNo => {
    PostApi1608(userinfo, cfg, phonecfg, seqNo)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          request1605(userinfo);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const goToPay = (seqNo, procStat, list) => {
    // 결제페이지 이동
    if (procStat == "01") {
      _O.OpenMenu("/pmr/proof/pay/" + seqNo);
    }

    if (procStat == "02") {
      // 결제취소 확인 confirm payMth, payAmount 없음
      handleConfirm(
        "결제취소",
        "발급을 취소하겠습니까?",
        seqNo,
        list.hsptCd,
        list.payMth,
        list.payAmount,
        list.pgCno,
        "CNCL"
      );
      // cancelPayment(list.trnsnNo, list.seqNo, list.pgCno, "40", "0.0.0.0", "648");
    }
  };

  const goToHist = (seqNo, procDh) => {
    _O.OpenMenu(
      "/proof/complete/" + seqNo + "/DTL/" + procDh + "/" + userinfo.userToken
    );
  };

  const cancelPayment = (
    trnsnNo,
    shopOrderNo,
    pgCno,
    reviseTypeCode,
    clientIp,
    clientId
  ) => {
    const payData = {
      userToken: userinfo.userToken,
      trnsnNo: trnsnNo.toString(),
      shopOrderNo: shopOrderNo.toString(),
      pgCno: pgCno,
      reviseTypeCode: reviseTypeCode,
      clientIp: clientIp,
      clientId: clientId,
    };

    postApiToJson(cfg.webUrl + "payment/cancel", payData)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          alert("성공");
        } else {
          // 취소실패
          alert("실패");
        }
      })
      .catch(err => {
        console.log("에러");
      });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirm = (
    title,
    msg,
    seqNo,
    hsptCd,
    patMth,
    payAmount,
    pgCno,
    mode
  ) => {
    setDialog({
      title: title,
      msg: msg,
    });

    setTrgtSeqNo(seqNo);
    setTrgtHsptCd(hsptCd);
    setPayMth(patMth);
    setPayAmount(payAmount);
    setPgCno(pgCno);
    setPopupMode(mode);
    /*
     * shopTransactionId, shopOrderNo, pgCno, reviseTypeCode, clientIp, clientId
     */
    openLayerFn($(".confirm-layer"));
  };

  const handleConfirmConfirmCB = () => {
    if (popupMode == "CNCL") {
      request1607(
        trgtHsptCd,
        trgtSeqNo,
        payMth,
        payAmount,
        "05",
        pgCno,
        "SUCCESS"
      );
    } else {
      // request1608(trgtSeqNo);

      socketManager(SocketCommand.FILE_UPLOAD, undefined, {
        type: "delete",
        userToken: userinfo.userToken.toString(),
        masterKeys: [
          { masterKey1: trgtSeqNo.toString(), masterKey2: "", masterKey3: "" },
        ],

        bizType: "PF",
        bizName: "제증명",
        bizDtlType: "",
        viewYN: "N",
        saveExtYN: "N",
        redirectURL: "cnntHspt/1",
        colorType: "PP",
        hsptSharYn: "N",
        bizSubType: "3",
      });
    }
  };

  const handleConfirmCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const reloadList = () => {
    if (periodType == 4) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1605Test(userinfo);
        setLoading(true);
      } else {
        setLoading(true);
        setAprvDataList([]);
      }
    } else {
      request1605Test(userinfo);
      setLoading(true);
    }
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  useEffect(() => {
    reloadList();
  }, [periodType, startDate, endDate]);

  useEffect(() => {
    if (loading) {
      request1605(userinfo2);
      setLoading(false);
    }
  }, [loading]);

  useEffect(() => {
    userHabit(phonecfg, "PF031");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  useEffect(() => {
    request1605(userinfo2);
  }, [props.match.params.reload]);

  useEffect(() => {
    if (itemState.reload || pageState.reload) {
      reloadList();
      requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);

      if (itemState.reload) {
        dispatch({
          type: SET_ITEMSTATE,
          data: "reload",
        });
      }
      if (pageState.reload) {
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload" },
        });
      }
    }
  }, [itemState.reload, pageState.reload]);

  const [aprvDataList, setAprvDataList] = useState([]);
  const [existingDataList, setExistingDataList] = useState([]);
  useEffect(() => {
    if (resultList) {
      // 필터링 전 초기화
      setAprvDataList([]);
      setExistingDataList([]);
      // 필터링
      resultList.filter(function (data, index) {
        if (data.newYn === "Y") {
          setAprvDataList(aprvDataList => [...aprvDataList, data]);
        } else {
          setExistingDataList(existingDataList => [...existingDataList, data]);
        }
      });
    }
  }, [resultList]);

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  useEffect(() => {
    requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
  }, []);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="제증명보관함"
        msgCount={msgCount}
        goToUrl="/"
        color="purple">
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} sub={SUBS} />
          {/* /subTabMenu */}

          <div className="sub-contents">
            <div className="steps-bar-area">
              <ul>
                <li style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofRecipt")}>
                    제증명 신청
                  </a>
                </li>
                <li className="on" style={{ width: "50%" }}>
                  <a
                    style={{
                      height: "55px",
                      lineHeight: "55px",
                      fontSize: "15px",
                      fontWeight: "bold",
                    }}
                    onClick={() => _O.OpenMenu("/pmr/proofList/3/1/1")}>
                    제증명 보관함
                  </a>
                </li>
                {/* <li><a>STEP 4</a></li> */}
              </ul>
            </div>

            <PeriodSetting
              setPeriodType={setPeriodType}
              periodType={periodType}
              startDate={startDate}
              endDate={endDate}
            />

            <div className="keepbox-round-list">
              {/* 리스트 컴포넌트 */}
              {aprvDataList.length > 0 && (
                <>
                  <SelectAllText>새로운 서류</SelectAllText>
                  <SelectAllSubText>
                    {" "}
                    {"*"} 1주일 이후 진료일별 자료에서 제공됩니다.
                  </SelectAllSubText>
                </>
              )}
              {aprvDataList &&
                aprvDataList != "" &&
                aprvDataList.map((m, i) => (
                  <PaperComponent
                    list={m}
                    goToPay={goToPay}
                    handleConfirm={handleConfirm}
                    periodType={periodType}
                    startDate={startDate}
                    endDate={endDate}
                    setPopupMode={setPopupMode}
                    goToHist={goToHist}
                    reloadList={reloadList}
                    downMode={downMode}
                    setDownMode={setDownMode}
                    key={i}
                  />
                ))}
              {existingDataList.length > 0 && (
                <SelectAllText>신청일별 서류</SelectAllText>
              )}
              {existingDataList &&
                existingDataList != "" &&
                existingDataList.map((m, i) => (
                  <PaperComponent
                    list={m}
                    goToPay={goToPay}
                    handleConfirm={handleConfirm}
                    periodType={periodType}
                    startDate={startDate}
                    endDate={endDate}
                    setPopupMode={setPopupMode}
                    goToHist={goToHist}
                    reloadList={reloadList}
                    downMode={downMode}
                    setDownMode={setDownMode}
                    key={i}
                  />
                ))}

              {aprvDataList.length === 0 && existingDataList.length === 0 && (
                <NoData>전송된 파일이 없습니다.</NoData>
              )}
              {/* 리스트 컴포넌트 */}
            </div>
          </div>
        </div>
      </Container>
      <DateLayer handleDate={handleDate} />
      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleConfirmCancelCB}
        handleConfirmCB={handleConfirmConfirmCB}
      />
      <LoadingLayer />
    </Fragment>
  );
};

export const PeriodSetting = (props) => {
  const { setPeriodType, periodType, startDate, endDate } = props;

  useEffect(() => {
    $(".date-setting-area .btns a").click(function () {
      $(".date-setting-area .btns a").removeClass("on");
      $(this).addClass("on");
      var idx = $(this).index();
      if (idx == 3) {
        //직접 기간설정
        $(".date-setting-area .date-input").slideDown("fast");
      } else {
        $(".date-setting-area .date-input").slideUp("fast");
      }
    });

    if (periodType == "9") {
      $(".pick-num1").val(
        startDate.substring(0, 4) +
          "." +
          startDate.substring(4, 6) +
          "." +
          startDate.substring(6, 8)
      );

      $(".pick-num2").val(
        endDate.substring(0, 4) + "." + endDate.substring(4, 6) + "." + endDate.substring(6, 8)
      );
    }
  }, []);

  return (
    <div className="date-setting-area">
      <div className="btns">
        <a style={{ height: "28px", lineHeight: "28px" }} onClick={() => setPeriodType(1)}>
          1주일
        </a>
        <a style={{ height: "28px", lineHeight: "28px" }} onClick={() => setPeriodType(2)}>
          1개월
        </a>
        <a
          style={{ height: "28px", lineHeight: "28px" }}
          onClick={() => setPeriodType(3)}
          className="on"
        >
          3개월
        </a>
        <a
          style={{ height: "28px", lineHeight: "28px" }}
          onClick={() => setPeriodType(4)}
          className="btn-selfinput"
        >
          기간설정
        </a>
      </div>
      <div className="date-input">
        <div className="round-bar">
          <div className="ipbox">
            <input
              type="text"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num1"
              data-num="1"
            />
            <i></i>
          </div>
          <u>~</u>
          <div className="ipbox">
            <input
              type="text"
              placeholder="선택하세요."
              readOnly
              className="date-picker-input pick-num2"
              data-num="2"
            />
            <i></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PaperComponent = (props) => {
  const {
    list,
    goToPay,
    handleConfirm,
    periodType,
    startDate,
    endDate,
    setPopupMode,
    goToHist,
    reloadList,
    downMode,
    setDownMode,
  } = props;

  const { userinfo, phonecfg } = useContext(AppContext);

  const eventDownLoad = (
    fileSeq,
    dnFileNm,
    fileExt,
    fileSize,
    dnYn,
    hsptSharYn,
    seqNo,
    hsptNm,
    schdlNm
  ) => {
    // $("#loadingLayer").show();
    downloadPfFile(userinfo.userToken, fileSeq);
  };

  return (
    <div>
      <div className="inbox">
        {list.modProcStat != "02" && (
          <button
            className="btn_delete"
            onClick={() =>
              handleConfirm(
                "문서삭제",
                "문서를 삭제하겠습니까?",
                list.seqNo,
                list.hsptCd,
                list.payMth,
                list.payAmount,
                list.pgCno,
                "DEL"
              )
            }></button>
        )}

        {/* {(list.modProcStat == '01' || list.modProcStat == '02')  */}
        {list.modProcStat == "01" ? (
          <span>{list.hsptNm}</span>
        ) : list.payYn === "Y" ? (
          <span onClick={() => goToHist(list.seqNo, list.procDh)}>
            {list.hsptNm}
          </span>
        ) : list.modProcStat != "09" ? (
          <span onClick={() => goToHist(list.seqNo, list.procDh)}>
            {list.hsptNm}
          </span>
        ) : (
          <span>{list.hsptNm}</span>
        )}
        <p>
          {/* 날짜 고정 */}
          {list.date1}({list.date2}){/* procStat에 따른 MSG */}
          {list.modProcStat == "01" && " (미결제)"}
          {list.modProcStat == "02" && " (문서접수중)"}
          {list.modProcStat == "03" && " (문서생성중)"}
          {list.modProcStat == "04" && " (병원반려)"}
          {list.modProcStat == "05" && " (결제취소완료)"}
          {list.modProcStat == "06" && " (결제취소반려)"}
          {list.modProcStat == "11" && " (결제취소요청중)"}
        </p>

        <StatusMsg status={list.modProcStat} />

        {/* 조건 노출: 반려사유가 있는경우 */}
        {list.rejctRsn && (
          <div
            style={{
              border: "1px solid #000",
              background: "#fff",
              borderRadius: "10px",
              fontSize: "14px",
              padding: "0px 10px",
              margin: "8px 10px",
            }}>
            {list.rejctRsn}
          </div>
        )}

        {(list.modProcStat == "01" || list.modProcStat == "02") && (
          <BtnGoToPay goToPay={goToPay} list={list} />
        )}

        <ul>
          {list.hsptProfAplnDocList &&
            list.hsptProfAplnDocList.map((m, i) => (
              <li key={i}>
                {m.docTypeNm}
                {(list.modProcStat === "09" || list.modProcStat === "10") && (
                  <a
                    id={m.seqNo.toString() + i}
                    name={m.dnYn}
                    onClick={() =>
                      eventDownLoad(
                        m.seqNo,
                        m.dnFileNm,
                        m.fileExt,
                        m.fileSize,
                        m.dnYn,
                        "N",
                        list.seqNo,
                        list.hsptNm,
                        m.docTypeNm
                      )
                    }>
                    {m.dnYn == "Y" ? "확인" : "다운로드"} <i></i>
                  </a>
                )}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

const BtnGoToPay = (props) => {
  const { goToPay, list } = props;
  return (
    <a style={{ fontSize: "13px" }} onClick={() => goToPay(list.seqNo, list.modProcStat, list)}>
      <div
        style={{
          textAlign: "center",
          color: "#fff",
          background: "#afb8e7",
          borderRadius: "3px",
          lineHeight: "32px",
          height: "32px",
          padding: "0px 15px",
          marginTop: "10px",
        }}
      >
        {list.modProcStat == "01" && "결제하기"}
        {list.modProcStat == "02" && "결제취소"}
      </div>
    </a>
  );
};

const StatusMsg = (props) => {
  const { status } = props;
  // {list.modProcStat == '01' && ' (미결제)'}
  // {list.modProcStat == '02' && ' (문서접수중)'}
  // {list.modProcStat == '03' && ' (문서생성중)'}
  // {list.modProcStat == '04' && ' (병원반려)'}
  // {list.modProcStat == '05' && ' (결제취소완료)'}
  // {list.modProcStat == '06' && ' (결제취소반려)'}
  // {list.modProcStat == '11' && ' (결제취소요청중)'}
  return (
    <Fragment>
      {/* {status == "01" &&
                <p style={{marginTop: "10px"}}>하단 결제하기 버튼으로 결제를 이어하실 수 있습니다.</p>
            } */}
      {status == "02" && (
        <p style={{ marginTop: "10px" }}>병원에서 신청내역을 확인하고 있습니다.</p>
      )}
      {status == "03" && (
        <p style={{ marginTop: "10px" }}>병원에서 요청서류를 준비하고 있습니다.</p>
      )}
      {status == "04" && (
        <p style={{ marginTop: "10px" }}>아래의 사유로 반려되었으며 결제 취소 되었습니다.</p>
      )}
      {/* {status == "05" &&
                <p style={{marginTop: "10px"}}>병원에서 신청내역을 확인하고 있습니다.</p>
            } */}
      {status == "06" && (
        <p style={{ marginTop: "10px" }}>아래의 사유로 반려되었으며 결제 취소가 반려 되었습니다.</p>
      )}
    </Fragment>
  );
};

const SelectAllText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;

  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;
`;

const SelectAllSubText = styled.div`
  font-weight: 400;
  font-size: 0.625rem;
  line-height: 16px;
  color: #6a62e6;

  display: inline-block;
  box-sizing: border-box;
  flex-direction: column;

  padding-left: 8px;
`;
